<p-buttongroup>
    @for (option of visibleOptions(); track option.id; let first = $first, last = $last) {
        @if (option.hasConfirmation) {
            <btn-confirm
                [id]="option.id + '-' + itemId()"
                [message]="option.confirmationMessage || ''"
                [acceptLabel]="option.confirmationAcceptLabel || 'uiKit.buttons.buttonConfirm.acceptLabel'"
                [rejectLabel]="option.confirmationRejectLabel || 'uiKit.buttons.buttonConfirm.rejectLabel'"
                [icon]="option.icon"
                [size]="size()"
                [severity]="option.severity || 'secondary'"
                [class.first-btn]="visibleOptions().length > 1 && first"
                [class.last-btn]="visibleOptions().length > 1 && last"
                [class.single-btn]="visibleOptions().length === 1"
                [class.no-right-border]="visibleOptions().length > 1 && !last"
                [fullWidth]="true"
                [rounded]="option.rounded || false"
                [outlined]="outlined()"
                [disabled]="disabled()"
                [pTooltip]="option.tooltip || '' | translate"
                [tooltipPosition]="'top'"
                [tooltipDisabled]="!option.tooltip"
                [loading]="option.isLoading || false"
                [acceptStyleClass]="option?.confirmationAcceptLabelStyleClass || ''"
                (accept)="option.onClick()"></btn-confirm>
        } @else {
            <btn-icon
                [id]="option.id + '-' + itemId()"
                [icon]="option.icon"
                [class.first-btn]="visibleOptions().length > 1 && first"
                [class.last-btn]="visibleOptions().length > 1 && last"
                [class.single-btn]="visibleOptions().length === 1"
                [class.no-right-border]="visibleOptions().length > 1 && !last"
                [severity]="option.severity || 'secondary'"
                [size]="size()"
                [ariaLabel]="option.ariaLabel || ''"
                [outlined]="outlined()"
                [disabled]="disabled()"
                [pTooltip]="option.tooltip || '' | translate"
                [tooltipPosition]="'top'"
                [tooltipDisabled]="!option.tooltip"
                [rounded]="option.rounded || false"
                [loading]="option.isLoading || false"
                (onClick)="option.onClick()"></btn-icon>
        }
    }
</p-buttongroup>
